export default [{
        id: 1,
        text: "nope..",
    },
    {
        id: 2,
        text: "still not it",
    },
    {
        id: 3,
        text: "sorry, but no..",
    },
    {
        id: 4,
        text: "arg that's not it bromingo",
    },
    {
        id: 5,
        text: "so close !",
    },
    {
        id: 6,
        text: "i'd really like to let you in..",
    },
    {
        id: 7,
        text: "security level: fort knox",
    },
    {
        id: 8,
        text: "sorry, but you can't go further",
    },
    {
        id: 9,
        text: "did you even buy the record bruh ?",
    },
    {
        id: 10,
        text: "if only you could see what's behind..",
    },
    {
        id: 11,
        text: "so not original you could guess it",
    },
    {
        id: 12,
        text: "get your passworld on <a href='https://kizi404.bandcamp.com/releases' target='_blank'>bandcamp</a>",
    }, {
        id: 13,
        text: "did you find your orbital care package",
    },{
        id: 14,
        text: "get on Facebook, ask for Kizi 404",
    }
]